import styled, { css } from 'styled-components';
import { countryCodes } from 'interfaces/common';

export const StyledWrapper = styled.div<{ country: countryCodes }>`
  ${props =>
    props.country === 'NZL' &&
    css`
      select {
        display: none;
      }
    `}
`;
